import React from 'react';
import I18n from '@/modules/i18n';
import Modal, { Footer } from '@/components/common/Modal';
import { LinkButton, UnstyledButton } from '@/components/ui/Buttons';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';

type RubricSelectModalProps = {
  isOpen: boolean;
  onClose: () => void;
  setRubricType: React.Dispatch<React.SetStateAction<'holistic' | 'analytic' | null>>;
  openAddModal: () => void;
};

const BUTTON_CLASSES = 'tw-w-full tw-h-[5.5rem] tw-border-med-grey tw-border-solid tw-border-[0.5px] tw-rounded-md '
  + 'tw-mt-4 tw-text-left tw-px-4 hover:tw-opacity-80';

const RubricSelectModal = ({ isOpen, onClose, openAddModal, setRubricType }: RubricSelectModalProps) => {
  const handleOpenAddModal = (rubricType: 'analytic' | 'holistic') => {
    setRubricType(rubricType);
    openAddModal();
    onClose();
  };

  return (
    <Modal className="tw-w-[30rem]" closeModal={onClose} headerText={I18n.t('create_rubric')} isOpen={isOpen}>
      <LinkButton className="tw-flex tw-items-center tw-mt-8 tw-my-0 tw-p-0" onClick={onClose}>
        <Icon className="tw-text-tci-purple tw-mr-2" icon="ArrowLeft" size={16} />
        <Text className="tw-text-tci-purple">{I18n.t('back')}</Text>
      </LinkButton>
      <Text className="!tw-text-dark-grey tw-mt-6" size="sm">
        {I18n.t('choose_rubric_type')}
      </Text>
      <UnstyledButton
        className={BUTTON_CLASSES}
        type="button"
        onClick={() => handleOpenAddModal('analytic')}
      >
        <Text size="lg">{I18n.t('analytic_rubric')}</Text>
        <Text className="!tw-text-dark-grey" size="sm">
          {I18n.t('multiple_criteria_with_detailed_scoring')}
        </Text>
      </UnstyledButton>
      <UnstyledButton
        className={BUTTON_CLASSES}
        type="button"
        onClick={() => handleOpenAddModal('holistic')}
      >
        <Text size="lg">{I18n.t('holistic_rubric')}</Text>
        <Text className="!tw-text-dark-grey" size="sm">
          {I18n.t('holistic_rubric_description')}
        </Text>
      </UnstyledButton>

      <Footer displaySubmitButton={false}>
        <LinkButton onClick={onClose}>{I18n.t('cancel')}</LinkButton>
      </Footer>
    </Modal>
  );
};

export default RubricSelectModal;
